import { render, staticRenderFns } from "./AuditReportConfig.vue?vue&type=template&id=182a6508&scoped=true&"
import script from "./AuditReportConfig.vue?vue&type=script&lang=js&"
export * from "./AuditReportConfig.vue?vue&type=script&lang=js&"
import style0 from "./AuditReportConfig.vue?vue&type=style&index=0&id=182a6508&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182a6508",
  null
  
)

export default component.exports